import jwt_decode from 'jwt-decode'

const SECRET_KEY = process.env.REACT_APP_API_TOKEN

export const encryptData = (data) => {
  const encrypt = jwt_decode(data.toString(), SECRET_KEY)
  return encrypt
}

export const decryptData = async (data) => {
  const decrypt = await jwt_decode(data, SECRET_KEY)

  
  return decrypt
}